import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";


dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);


export const TimeUtil = {
    now(): Dayjs {
        return dayjs();
    },

    utcNow(): Dayjs {
        return dayjs.utc();
    },

    /**
    * Subtract `days` from `date`.
    * @param date - any dayjs-accepted input
    * @param days - number
    */
    subtractDays(date: dayjs.ConfigType, days: number): Dayjs {
        return dayjs(date).subtract(days, "day");
    },
    subtractWeeks(date: dayjs.ConfigType, weeks: number): Dayjs {
        return dayjs(date).subtract(weeks, "week");
    },
    toDate(date: string, format: string = "YYYY-MM-DD"): Dayjs {
        return dayjs(date, format);
    }
} as const;